import { useSelector, useDispatch } from 'react-redux'
import { useSwipeable} from 'react-swipeable'
import _ from 'lodash'
import {Link} from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
// css
import './css/gallerieviewer.css'
//DATA
import GVdata from './GVdata'
//Actions 
import { hideGallerieViewer } from '../reducers/ActionsCreator'

const GallerieViwer = ({ viewer }) => {
	const dispatch = useDispatch()
	const gallerieReducer = useSelector(state => state.GallerieReducer)
	const handlers = useSwipeable({
		onSwipedDown: () => dispatch(hideGallerieViewer())
	})
	const GVobj = _.find(GVdata, {img: gallerieReducer.img})
	return(
		<AnimatePresence>
			<motion.div className="gv_main_container">
					<div className="gv_child_wrapper"  >
							<motion.div {...handlers} className="gv_child" key='rer' initial={{y:"100%"}} animate={{y:0}} transition={{duration:.4}} exit={{y:"100%"}}>
								<div className="gv_topbar"></div>
								
								<div className="gv_img_container">
									<button onClick={() => dispatch(hideGallerieViewer())} ><i className="fas fa-times"></i></button>
									<img src={require(`../images/static/gallerie/${gallerieReducer.img}.jpg`)} alt="" />
								</div>
	
								<div className="gv_content">
									<div>
										<p className="gv_title">{GVobj.name}</p>
										<div className="gv_types_container">{GVobj.types.map((type, index) => 
											<span className={type==="blog"?"blog":type==="store"?"store":type==="experimental"?"experimental":"chat"}>{type}</span>
										)}</div>
										<div>
											{GVobj.guthub?
												<a href={GVobj.guthub}>find on my Github</a>
												:
												<p className="github_not_available">Github link for this project is not available for the moment!</p>
											}
										</div>
									</div>
	
									<div className="gv_state_container">
										<div className="state">
											<p>100%</p>
											<p>done</p>
										</div>
										<div className="gv_tools">
											<p>Framework & tools used in this project</p>
											<div>
												{GVobj.tools.map((tool, index) => 
													<span key={index} className={tool==="html 5"?"html_5":tool==="css 3"?"css_3":tool==="javascript"?"javascript":tool==="React"?"react":tool==="Express"?"express":tool==="EJS Engine"?"ejs":tool==="graphql"?"graphql":tool==="rest api"?"rest":tool==="MongoDB"?"mongo":tool==="Firebase"?"firebase":tool==="Redis"?"redis":tool=="Redux"?"redux":"socketio"}>
														{tool}
													</span>
												)}
											</div>
										</div>
									</div>
								</div>
							</motion.div>
					</div>
			</motion.div>
			</AnimatePresence>
	)
}

export default GallerieViwer